import React from 'react';

const Rewards = (props) => {
  const {
    handleMenu,
    links
  } = props;

  return (
    <div className="nav-menu-links-list nav-menu-rewards">
      <h4 onClick={() => handleMenu()}>REWARDS</h4>
      <div className="header-underline" />
      {links}
    </div>
  );
};

export default Rewards;



// WEBPACK FOOTER //
// ./src/components/layout/user-navigation/navbar-items/rewards.jsx